'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _helpers = require('../../helpers');

var _formFields = require('../form-fields');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = function validate(values) {
  var errors = {};

  if (values.newPassword !== values.confirmPassword) {
    errors.newPassword = 'Passwords do not match.';
    errors.confirmPassword = 'Passwords do not match.';
  }

  return errors;
};

var ResetPasswordForm = (0, _reduxForm.reduxForm)({ form: 'resetPassword', validate: validate })(function (props) {
  var handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      resetPassword = props.resetPassword;


  return _react2.default.createElement(
    'form',
    { onSubmit: handleSubmit(resetPassword) },
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required, _helpers.minLength8],
      name: 'newPassword',
      type: 'password',
      label: 'New Password',
      autoComplete: 'new-password'
    }),
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required, _helpers.minLength8],
      name: 'confirmPassword',
      type: 'password',
      label: 'Confirm Password',
      autoComplete: 'new-password'
    }),
    _react2.default.createElement('input', {
      type: 'submit',
      value: 'Change Password',
      disabled: submitting,
      className: 'button w-button ' + (submitting ? 'disabled-btn' : null)
    })
  );
});

exports.default = ResetPasswordForm;